module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Discovery-Of-Witches-A-S1.c340dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Discovery-Of-Witches-A-S1.jpg
// module id = MqbP
// module chunks = 0